var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-image"},[_c('v-img',{staticClass:"image-content",attrs:{"src":_vm.question.image,"max-height":("calc(100vh - " + _vm.headerHeight + "px)")}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }